<template>
  <div class="index-container">
    <CuHeader title="预问诊-让医生更早了解您的病情"></CuHeader>
    <!-- 首诊问卷内容 -->
    <ul class="content">
      <li
        v-for="(item, index) in list"
        :key="item.id"
        class="item"
        :id="'item' + index"
      >
        <!-- 文本域 -->
        <template v-if="item.type == 'textarea'">
          <span :class="item.required ? 'title-before' : ''" class="title"
            >{{ index + 1 + "." + item.label
            }}<p v-if="item.ishtml" style="color: rgba(218, 41, 19, 1);margin: 0;">{{
              item.ishtml
            }}</p>
          </span>
          <van-field
            autosize
            rows="1"
            v-model="item.value"
            :label-align="'top'"
            clearable
            type="textarea"
            placeholder="请输入"
            :disabled="modelStatus == 2"
            class="border-item"
            @focus="handleFocus(index)"
            @blur="handleBlur(index)"
            :id="'otherinput_' + index"
          >
            <!-- 语音录入 -->
            <!-- <template #button v-if="modelStatus != 2">
              <van-icon
                name="volume-o"
                :class="indexActive == index ? 'circle' : ''"
                color="#2d57a0"
                id="btn_control"
                :data-index="index"
                @touchstart="voiceStart(index)"
                @touchend="voiceEnd"
              />
            </template> -->
          </van-field>
        </template>
        <!-- 多选 -->
        <template v-else-if="item.type == 'checkbox'">
          <span :class="item.required ? 'title-before' : ''" class="title"
            >{{ index + 1 + "." + item.label
            }}<p v-if="item.ishtml" style="color: rgba(218, 41, 19, 1);margin: 0;">{{
              item.ishtml
            }}</p></span
          >
          <van-checkbox-group
            v-model="item.value"
            direction="horizontal"
            :disabled="modelStatus == 2"
            :id="'otherinput_' + index"
          >
            <van-checkbox
              shape="square"
              :name="it.value"
              v-for="it in item.options"
              :key="it.value"
              @click="handleCheckbox(index, it)"
              class="radio-font-size"
              >{{ it.label }}</van-checkbox
            >
            <!-- 更新valu值 v-if="item.isOther" -->
            <van-field
              autosize
              clearable
              placeholder="请输入"
              v-if="item.isOther"
              :disabled="modelStatus == 2"
              v-model="item.isOtherValue"
              @focus="handleFocus(index)"
              @blur="handleBlur(index)"
            >
              <!-- 语音录入 -->
              <!-- <template #button v-if="modelStatus != 2">
                <van-icon
                  name="volume-o"
                  :class="indexActive == index ? 'circle' : ''"
                  color="#2d57a0"
                  id="btn_control"
                  :data-index="index"
                  @touchstart="voiceStart(index)"
                  @touchend="voiceEnd"
                />
              </template> -->
            </van-field>
          </van-checkbox-group>
        </template>
        <!-- 包含外院检查发现 -->
        <template v-else-if="item.type == 'isOtherHostial'">
          <span :class="item.required ? 'title-before' : ''" class="title"
            >{{ index + 1 + "." + item.label
            }}<p v-if="item.ishtml" style="color: rgba(218, 41, 19, 1);margin: 0;">{{
              item.ishtml
            }}</p></span
          >
          <van-radio-group
            v-model="item.value"
            shape="square"
            direction="horizontal"
            :disabled="modelStatus == 2"
            :id="'otherinput_' + index"
          >
            <van-radio
              :name="it.value"
              v-for="it in item.options"
              :key="it.value"
              @click="handleIsOtherHostial(index, it)"
              class="radio-font-size"
              >{{ it.label }}</van-radio
            >
            <!-- 更新valu值 v-if="item.isOther" -->
            <van-field
              autosize
              clearable
              placeholder="请输入"
              v-if="item.isOther"
              :disabled="modelStatus == 2"
              v-model="item.isOtherValue"
              @focus="handleFocus(index)"
              @blur="handleBlur(index)"
            >
              <!-- 语音录入 -->
              <!-- <template #button v-if="modelStatus != 2">
                <van-icon
                  name="volume-o"
                  :class="indexActive == index ? 'circle' : ''"
                  color="#2d57a0"
                  id="btn_control"
                  :data-index="index"
                  @touchstart="voiceStart(index)"
                  @touchend="voiceEnd"
                />
              </template> -->
            </van-field>
            <!-- 更新valu值 v-if="item.isOther" -->
            <van-field
              autosize
              clearable
              placeholder="诊治情况及疗效"
              v-if="item.isOtherHostial"
              :disabled="modelStatus == 2"
              v-model="item.isOtherHostialValue"
            >
            </van-field>
          </van-radio-group>
        </template>
        <!-- 单选 -->
        <template v-else-if="item.type == 'radio'">
          <span :class="item.required ? 'title-before' : ''" class="title"
            >{{ index + 1 + "." + item.label
            }}<p v-if="item.ishtml" style="color: rgba(218, 41, 19, 1);margin: 0;">{{
              item.ishtml
            }}</p></span
          >
          <van-radio-group
            v-model="item.value"
            shape="square"
            direction="horizontal"
            :disabled="modelStatus == 2"
            :id="'otherinput_' + index"
          >
            <van-radio
              :name="it.value"
              v-for="it in item.options"
              :key="it.value"
              class="radio-font-size"
              @click="handleRdiobox(index, it)"
              :style="item.styleCustomize && JSON.parse(item.styleCustomize)"
              >{{ it.label }}</van-radio
            >
            <van-field
              autosize
              clearable
              placeholder="请输入"
              v-if="item.isOther"
              :disabled="modelStatus == 2"
              v-model="item.isOtherValue"
              @focus="handleFocus(index)"
              @blur="handleBlur(index)"
            >
              <!-- 语音录入 -->
              <!-- <template #button v-if="modelStatus != 2">
                <van-icon
                  name="volume-o"
                  :class="indexActive == index ? 'circle' : ''"
                  color="#2d57a0"
                  id="btn_control"
                  :data-index="index"
                  @touchstart="voiceStart(index)"
                  @touchend="voiceEnd"
                />
              </template> -->
            </van-field>
          </van-radio-group>
        </template>
        <!-- 特殊 -->
        <template v-else-if="item.type == 'mdw'">
          <span :class="item.required ? 'title-before' : ''" class="title"
            >{{ index + 1 + "." + item.label }}
            <p v-if="item.ishtml" style="color: rgba(218, 41, 19, 1);margin: 0;">{{
              item.ishtml
            }}</p>
          </span>
          <van-row
            type="flex"
            align="center"
            :gutter="20"
          >
            <van-col span="10">
              <!-- 更新valu值 -->
              <!-- <van-field
                clearable
                placeholder="请输入"
                v-if="item.isOther"
                type="digit"
                :disabled="modelStatus == 2"
                v-model="item.isOtherValue"
              ></van-field> -->
              <div style="display: flex; align-items: center">
                <van-button
                  type="info"
                  size="small"
                  class="number_button"
                  @click="handleUpdateTime(item, 'reduce')"
                  >-</van-button
                >
                <!-- <span class="number" style="font-size: 12px">{{
                  item.isOtherValue
                }}</span> -->
                <van-field
                  v-model="item.isOtherValue"
                  type="digit"
                  :border="false"
                  center
                  class="item_buttom_center"
                />
                <van-button
                  type="info"
                  size="small"
                  class="number_button"
                  @click="handleUpdateTime(item, 'add')"
                  >+</van-button
                >
              </div>
            </van-col>
            <van-col span="14">
              <van-radio-group
                v-model="item.value"
                shape="square"
                direction="horizontal"
                :disabled="modelStatus == 2"
              >
                <van-radio
                  :name="it.value"
                  v-for="it in item.options"
                  :key="it.value"
                  class="radio-font-size"
                  style="margin-bottom: 0"
                  >{{ it.label }}</van-radio
                >
              </van-radio-group>
            </van-col>
          </van-row>
        </template>
        <!-- 多选与数字填写 -->
        <template v-else-if="item.type == 'checkboxAndNumbe'">
          <span :class="item.required ? 'title-before' : ''" class="title"
            >{{ index + 1 + "." + item.label
            }}<p v-if="item.ishtml" style="color: rgba(218, 41, 19, 1);margin: 0;">{{
              item.ishtml
            }}</p></span
          >
          <!-- 选项内容 -->
          <ul class="checkboxAndNumbe" :id="'otherinput_' + index">
            <li
              v-for="it in item.options"
              :key="it.id"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
              class="item"
            >
              <van-checkbox
                v-model="it.value"
                @click="handleFirstCheckbox(index, it)"
                >{{ it.label }}</van-checkbox
              >
              <select
                v-if="it.children"
                v-model="it.isSelect"
                :disabled="!it.value"
                class="item-option"
                @change="handleSelectOptions(it)"
              >
                <option
                  :value="i.value"
                  v-for="i in it.children"
                  :key="i.value"
                >
                  {{ i.key }}
                </option>
              </select>
              <!-- :disabled="it.isSelect == '斜视' || it.isSelect == '弱视'" -->
              <div style="display: flex; align-items: center">
                <van-button
                  type="info"
                  size="small"
                  class="number_button"
                  v-if="it.children"
                  :disabled="it.isSelect == '斜视' || it.isSelect == '弱视' || it.isSelect == '青光眼' || it.isSelect == '先天性白内障' ||!it.value"
                  @click="handleDescFirst(it, it.number)"
                  >-</van-button
                >
                <!-- <span v-if="it.children" class="number">{{ it.number }}</span> -->
                <van-field
                  v-model="it.number"
                  type="digit"
                  v-if="it.children"
                  class="number item_buttom_center"
                  :border="false"
                  center
                />
                <van-button
                  type="info"
                  size="small"
                  class="number_button"
                  v-if="it.children"
                  @click="handleAddFirst(it, it.number)"
                  :disabled="it.isSelect == '斜视' || it.isSelect == '弱视'|| it.isSelect == '青光眼' || it.isSelect == '先天性白内障' ||!it.value"
                  >+</van-button
                >
              </div>

              <span v-if="it.children">度</span>
              <!-- 更新valu值 v-if="item.isOther" -->
              <van-field
                autosize
                clearable
                placeholder="请输入"
                v-if="it.isOther"
                :disabled="modelStatus == 2"
                v-model="it.isOtherValue"
                style="width: 80%"
                @focus="handleFocus(index)"
                @blur="handleBlur(index)"
              >
                <!-- 语音录入 -->
                <!-- <template #button v-if="modelStatus != 2">
                  <van-icon
                    name="volume-o"
                    :class="indexActive == index ? 'circle' : ''"
                    color="#2d57a0"
                    id="btn_control"
                    :data-index="index"
                    @touchstart="voiceStart(index)"
                    @touchend="voiceEnd"
                  />
                </template> -->
              </van-field>
            </li>
          </ul>
        </template>
        <!-- 展开交付 -->
        <template v-else-if="item.type == 'isExpand'">
          <span :class="item.required ? 'title-before' : ''" class="title"
            >{{ index + 1 + "." + item.label
            }}<p v-if="item.ishtml" style="color: rgba(218, 41, 19, 1);margin: 0;">{{
              item.ishtml
            }}</p></span
          >
          <van-radio-group
            v-model="item.value"
            shape="square"
            direction="horizontal"
            :disabled="modelStatus == 2"
          >
            <van-radio
              :name="it.value"
              v-for="it in item.options"
              :key="it.value"
              class="radio-font-size"
              @click="handleIsExpand(item)"
              >{{ it.label }}</van-radio
            >
          </van-radio-group>
        </template>
      </li>
      <li
        style="display: flex; justify-content: center; color: red"
        v-if="modelStatus == 2"
      >
        当前信息已经提交，只能查看
      </li>
    </ul>
    <footer class="footer">
      <van-button
        type="primary"
        size="large"
        round
        @click="handleToDetail"
        v-if="modelStatus != 2"
        >完成</van-button
      >
      <van-button
        type="primary"
        size="large"
        round
        @click="handleToHistory"
        v-else
        >查看历史</van-button
      >
    </footer>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
import CuHeader from "../../components/CuHeader.vue";
import { getTemplate, saveAnswer } from "@/api/index";
import { getAnswer } from "@/api/detail.js";
import { initVoice, connectWebSocket, recorder } from "@/utils/Record.js";
import { getValue } from "@/utils/storage";
// import { listData } from "./config";
Vue.use(Toast);
let timer = null;
let countInterval = null;
let timeOutE = null;
export default {
  name: "Index-page",
  components: {
    CuHeader,
  },
  data() {
    return {
      list: [],
      templateId: null,
      visitNo: "",
      voiceRun: false,
      indexActive: -1,
      id: null,
      modelStatus: 1,
      peid: undefined,
      testVoice: false,
      rest1: [],
      rest2: [],
      listData: [],
      isSelect: "",
      lastVisitDate: '',
      words: ['近视', '远视', '弱视', '斜视', '散光'],
      lastSelectedItem: {},
    };
  },
  computed: {
    patientId() {
      return this.$store.state.token.patientId;
    },
  },
  mounted() {
    // 初始化语音
    initVoice(
      (bool) => {
        this.voiceRun = bool;
      },
      (index, text) => {
        if (index > -1) {
          const item = this.list[index];
          if (this.testVoice) {
            this.testVoiceInput(item.options, text);
          } else {
            if (item.isOther) {
              item.isOtherValue = text;
            } else {
              this.list[index].value = text;
            }
          }
        }
      }
    );
    // const baseData = [...listData];
    // this.list = baseData.filter((item) => {
    //   if (item.hasOwnProperty("isExpand")) {
    //     return item.isExpand;
    //   } else {
    //     return true;
    //   }
    // });
    const { id } = this.$route.query;
    // 返回修改页面或者再次进入模板页面
    if (id) {
      this.geAawertData();
    } else {
      // 获取空模板
      this.getData();
    }
  },
  // 销毁组件
  beforeDestroy() {
    timer && clearTimeout(timer);
    countInterval && clearTimeout(countInterval);
    timeOutE && clearTimeout(timeOutE);
  },
  methods: {
    handleUpdateTime(origin, type) {
      if (type === "add") {
        origin.isOtherValue = +origin.isOtherValue + 1;
      } else if (origin.isOtherValue > 1) {
        origin.isOtherValue -= 1;
      }
    },
    testVoiceInput(child, text) {
      for (let i = 0; i < child.length; i++) {
        const item = child[i];
        if (item.isOther) {
          item.isOtherValue = text;
          this.testVoice = false;
        }
      }
    },
    addQuotesToString(str, keywords) {
      keywords.forEach(keyword => {
        // 直接在关键词前后添加引号
        const regex = new RegExp(`${keyword}`, 'g');
        str = str.replace(regex, `"${keyword}"`);
      });
      return str;
    },
    firstVisitRule(type, fullData) {
      var text = '';
      var currentData;
      if (type === '主诉') {
        currentData = fullData['主诉'];
        if (currentData['描述'] === '' || currentData['描述'] === '视力无变化') {
          text = '要求行眼科检查';
          return text;
        }
        if (currentData['途径'] !== '') {
          text = `${currentData['途径']}`;
        }
        if (currentData['眼别'] !== '') {
          text += `${currentData['眼别']}`;
        }
        if (currentData['描述'] !== '') {
          text += `${currentData['描述']}`;
        } else {
          // text += `${fullData['主诉']['描述']['未提及']}`;
        }
        if (Array.isArray(currentData['伴随']) && currentData['伴随'].length) {
          text += `伴${currentData['伴随'].join('、')}`;
        }
        if (currentData['时间'] !== '') {
          text += `${currentData['时间']}`;
        }
        // 戴镜规则
        if (currentData['戴镜'] === '是') {
          if (currentData['描述'] === '未提及') {
            text = `戴镜${currentData['眼别']}${currentData['时间']}`;
          } else if (currentData['描述'] !== '') {
            text = `${currentData['眼别']}${currentData['描述']}${Array.isArray(currentData['伴随']) && currentData['伴随'].length ? `伴${currentData['伴随'].join('、')}` : ''}${currentData['时间']}`
          }
        }
        if (currentData['要求'] !== '') {
          text += `${currentData['要求']}`;
        }
        if (currentData['描述'] === '' && currentData['要求'] === '视力筛查') {
          text = '家属要求近控检查';
        }
        return this.addQuotesToString(text.replace(/undefined/g, ''), this.words);
      } else if (type === '现病史') {
        currentData = fullData['现病史'];
        text = `患者自述`;
        if (fullData['主诉']['时间'] !== '') {
          text += `${fullData['主诉']['时间']}前`;
        }
        if (currentData['机构'] !== '') {
          text += `${currentData['机构']}检查发现`;
        }
        if (currentData['描述'] !== '') {
          text += `，${currentData['描述']}`
        } else {
          text = ``;
        }
        text += `${text.length ? '，' : ''}${Array.isArray(fullData['主诉']['伴随']) && fullData['主诉']['伴随'].length ? `伴有${fullData['主诉']['伴随'].join('、')}` : "其余（-）"}`;
        var isOutside = currentData['外院'];
        switch (isOutside) {
          case '是':
            text += `。曾在外院就诊`;
            break;
          case '否':
            text += `。否认在外院就诊`;
            break;
        }
        if (isOutside === '是' && currentData['过程'] !== '') {
          text += `，${currentData['过程']}`;
        }
        text += `，${fullData['主诉']['要求'] !== '' ? `${fullData['主诉']['要求']}。` : '要求进一步诊疗。'}`;
        return this.addQuotesToString(text.replace(/undefined/g, ''), this.words);
      } else if (type === '既往史') {
        currentData = fullData['既往史'] || {};
        var isNullAll = true;
        for (let k in currentData) {
          if (currentData[k] !== '' && currentData[k] !== '否认') {
            isNullAll = false;
            break;
          }
        }
        if (isNullAll) {
          text = `（-）`;
          return text;
        } else {
          if (currentData['用药史'] !== '' && currentData['用药史'] !== '否认') {
            text = `${currentData['用药史']}，`;
          }
          if (currentData['父母婚育史'] !== '' && currentData['父母婚育史'] !== '否认') {
            text += `${currentData['父母婚育史']}，`;
          }
          if (currentData['疾病史'] !== '' && currentData['疾病史'] !== '否认') {
            text += `${currentData['疾病史']}，`;
          }
          if (currentData['手术史'] !== '' && currentData['手术史'] !== '否认') {
            text += `${currentData['手术史']}，`;
          }
          if (currentData['家族疾病史'] !== '' && currentData['家族疾病史'] !== '否认') {
            text += `${currentData['家族疾病史']}，`;
          }
          text += `其余（-）。`;
          return this.addQuotesToString(text.replace(/undefined/g, ''), this.words);
        }
      } else if (type === '过敏史') {
        currentData = fullData['过敏史'] || {};
        var isNullAll = true;
        for (let k in currentData) {
          if (currentData[k] !== '' && currentData[k] !== '否认') {
            isNullAll = false;
            break;
          }
        }
        if (isNullAll) {
          text = `药物过敏史（-）`;
          return text;
        } else {
          if (currentData['食物'] !== '' && currentData['食物'] !== '否认') {
            text = currentData['食物'].includes('过敏') ? `${currentData['食物']}。` : `${currentData['食物']}"过敏"。`;
          }
          if (currentData['体质'] !== '' && currentData['体质'] !== '否认') {
            text += currentData['体质'].includes('过敏') ? `${currentData['体质']}。`  : `${currentData['体质']}"过敏"。`;
          }
          if (currentData['药物'] !== '' && currentData['药物'] !== '否认') {
            text += currentData['药物'].includes('过敏') ? `${currentData['药物']}。`  : `${currentData['药物']}"过敏"。`;
          }
          return this.addQuotesToString(text.replace(/undefined/g, ''), this.words);
        }
      }
    },
    replyVisitRule(type, fullData) {
      var text = '';
      var currentData;
      if (type === '主诉') {
        currentData = fullData['主诉'] || {};
        text = `双眼"屈光不正"${currentData['时间']}复查`;
        return this.addQuotesToString(text.replace(/undefined/g, ''), this.words);
      } else if (type === '现病史') {
        currentData = fullData['现病史'] || {};
        if (currentData['经历']) {
          text = `${currentData['经历']}，`;
        }
        text += `${currentData['戴镜'] === '' || currentData['戴镜'] === '-' ? "戴镜（-）" : "戴镜（+）"}，`;
        if (currentData['时长']) {
          text += `现镜${currentData['时长']}，`;
        }
        text += `${currentData['阿托品'] === '+' ? "低浓度阿托品（+）" : "低浓度阿托品（-）"}，`;
        if (currentData['用药时间']) {
          text += `${currentData['用药时间']}，`;
        }
        if (currentData['其他不适'] && Array.isArray(currentData['其他不适']) && currentData['其他不适'].length) {
          text += `${currentData['其他不适'].join('，')}。`;
        } else {
          text += `其余（-）`;
        }
        return this.addQuotesToString(text.replace(/undefined/g, ''), this.words);
      } else if (type === '既往史') {
        currentData = fullData['既往史'] || {};
        var isNullAll = true;
        for (let k in currentData) {
          if (currentData[k]) {
            isNullAll = false;
            break;
          }
        }
        if (isNullAll) {
          text = `（-）`;
          return text;
        } else {
          if (currentData['用药史']) {
            text = `${currentData['用药史']}，`;
          }
          if (currentData['出生相关史']) {
            text += `${currentData['出生相关史']}，`;
          }
          if (currentData['疾病史']) {
            text += `${currentData['疾病史']}，`;
          }
          if (currentData['手术史']) {
            text += `${currentData['手术史']}，`;
          }
          if (currentData['家族疾病史']) {
            text += `${currentData['家族疾病史']}，`;
          }
          text += `其余（-）。`;
          return this.addQuotesToString(text.replace(/undefined/g, ''), this.words);
        }
      } else if (type === '过敏史') {
        currentData = fullData['过敏史'] || {};
        var isNullAll = true;
        for (let k in currentData) {
          if (currentData[k]) {
            isNullAll = false;
            break;
          }
        }
        if (isNullAll) {
          text = `药物过敏史（-）`;
          return text;
        } else {
          if (currentData['食物']) {
            text = currentData['食物'].includes('过敏') ? `${currentData['食物']}。` : `${currentData['食物']}"过敏"。`;
          }
          if (currentData['体质']) {
            text += currentData['体质'].includes('过敏') ? `${currentData['体质']}。`  : `${currentData['体质']}"过敏"。`;
          }
          if (currentData['药物']) {
            text += currentData['药物'].includes('过敏') ? `${currentData['药物']}。`  : `${currentData['药物']}"过敏"。`;
          }
          return this.addQuotesToString(text.replace(/undefined/g, ''), this.words);
        }
      }
    },
    getTimeCalcRes(lastVisitDate) {
      let now = new Date(); 
      // var patientLastVisit = dayjs(lastVisitDate);
      // var pLastVisitYear = patientLastVisit.year();
      // var pLastVisitMonth = patientLastVisit.month() + 1;
      let [pLastVisitYear, pLastVisitMonth] = lastVisitDate.split('-'); 
      console.log(' lastVisitDate->>', lastVisitDate, pLastVisitYear, pLastVisitMonth);
      if (pLastVisitYear && pLastVisitMonth) {
        var tempYY = now.getFullYear() - pLastVisitYear;
        var timeRes = '';
        if (tempYY < 0) {
          timeRes = `${now.getMonth() + 1 - pLastVisitMonth}月`
        } else if (tempYY === 1) {
          var mD = now.getMonth() + 1 - pLastVisitMonth;
          if (mD < 0) {
            timeRes = `${mD + 12}月`
          } else {
            timeRes = `1年`
          }
        } else {
          timeRes = `${tempYY}年`
        }
      }
      return timeRes;
    },
    replyVisitRuleForXBS(fullData) {
      let currentData = fullData['现病史'] || {};
      // let text = fullData['主诉']['患者意图'];
      let text = '';
      // if (currentData['经历']) {
      //   text += `患者${currentData['经历']}，${currentData['眼镜类型'] ? `配戴${currentData["眼镜类型"]}，` : ''}${currentData['矫正视力'] ? `矫正视力${currentData["矫正视力"]}，` : ''}`;
      // }
      text += `${currentData['戴镜'] === '' || currentData['戴镜'] === '-' ? "戴镜（-）" : "戴镜（+）"}，`;
      if (currentData['时长']) {
        text += `现镜${currentData['时长']}，`;
      }
      text += `${currentData['阿托品'] === '+' ? "低浓度阿托品（+）" : "低浓度阿托品（-）"}，`;
      if (currentData['用药时间']) {
        text += `${currentData['用药时间']}，`;
      }
      if (currentData['其他不适'] && Array.isArray(currentData['其他不适']) && currentData['其他不适'].length) {
        text += `${currentData['其他不适'].join('，')}。`;
      } else {
        text += `其余（-）`;
      }
      return this.addQuotesToString(text.replace(/undefined/g, ''), this.words);
    },
    updateBaseData(keyMap, baseArr, data) {
      data.forEach(item => {
        const path = keyMap[item.key]; // 获取路径
        if (path) {
          let target = baseArr;
          for (let i = 0; i < path.length - 1; i++) {
            target = target[path[i]];
          }
          const lastKey = path[path.length - 1];
          target[lastKey] = item.answer;
        }
      });
      return baseArr;
    },
    // 生成病历
    getGenerateMedicalRecord(visitLastTime, qData) {
      qData = qData.map(item => {
        return {
          ...item,
          answer: item.answer || '',
        };
      });
      var isFrist = !!!visitLastTime;
      let baseModel;
      if (isFrist) {
        baseModel = {
          "既往史": {
            "用药史": "",
            "手术史": "",
            "疾病史": "",
            "家族疾病史": "",
            "父母婚育史": ""
          },
          "过敏史": {
            "食物": "",
            "药物": "",
            "体质": ""
          },
          "主诉": {
            "戴镜": "",
            "途径": "",
            "眼别": "",
            "时间": "",
            "描述": "",
            "伴随": [],
            "要求": ""
          },
          "现病史": {
            "描述": "",
            "外院": "",
            "本院": "",
            "机构": "",
            "过程": ""
          }
        }
      } else {
        baseModel = {
          "主诉": {
            "时间": ""
          },
          "现病史": {
            "经历": "",
            "戴镜": "",
            "时长": "",
            "阿托品": "",
            "用药时间": "",
            "其他不适": []
          },
          "既往史": {
            "用药史": "",
            "疾病史": "",
            "手术史": "",
            "家族疾病史": "",
            "出生相关史": ""
          },
          "过敏史": {
            "食物": "",
            "药物": "",
            "体质": ""
          }
        }
      }
      let firstKeyMap = {
        "ZS_SFDJ": ["主诉", "戴镜"],
        "ZS_ZZFXTJ": ["主诉", "途径"],
        "ZS_FSZZDYJ": ["主诉", "眼别"],
        "ZS_ZZFSSJ": ["主诉", "时间"],
        "ZS_HZYQ": ["主诉", "要求"],
        "ZS_ZZMS": ["主诉", "描述"],
        "ZS_BSZZ": ["主诉", "伴随"],
        "JWS_JZJBS": ["既往史", "家族疾病史"],
        "JWS_GRYYS": ["既往史", "用药史"],
        "JWS_GRJBS": ["既往史", "疾病史"],
        "GMS_SWGM": ["过敏史", "食物"],
        // "XBS_ZZXXMS": ["现病史", "描述"],
        "XBS_ZLGC": ["现病史", "过程"],
      };
      let againKeyMap = {
        "ZS_HZYT": ["主诉", "患者意图"],
        "XBS_JZJL": ["现病史", "经历"],
        "XBS_QTYBBS": ["现病史", "其他不适"],
        "XBS_SFDJ": ["现病史", "戴镜"],
        "XBS_DJSC": ["现病史", "时长"],
        "XBS_SFSYGATP": ["现病史", "阿托品"],
        "XBS_ATPSYQK": ["现病史", "用阿托品的情况"],
        "XBS_YYSJ": ["现病史", "用药时间"],
        "XBS_JZJL2": ["现病史", "眼镜类型"],
        "XBS_DJSC2": ["现病史", "矫正视力"],
      };
      let tidyModelData = this.updateBaseData(isFrist ? firstKeyMap : againKeyMap, baseModel, qData);
      let generateMedicalHistory = {
        "主诉": '',
        "现病史": '',
        "既往史": '',
        "过敏史": '',
      };
      if (isFrist) {
        if (typeof tidyModelData['主诉']['伴随'] === 'string') {
          tidyModelData['主诉']['伴随'] = tidyModelData['主诉']['伴随'].split(',');
        }
        // tidyModelData['主诉']['伴随'] = tidyModelData['主诉']['伴随'] && tidyModelData['主诉']['伴随'].split(',');
        // tidyModelData['现病史']['描述'] = tidyModelData['现病史']['描述'] && tidyModelData['现病史']['描述'].split(',');
        let isOuterCheck = tidyModelData['主诉']['途径'].includes('外院检查');
        if (isOuterCheck) {
          tidyModelData['现病史']['外院'] = '是';
          let tempSplit = tidyModelData['主诉']['途径'].split(':');
          if (tempSplit.length === 2) {
            tidyModelData['现病史']['过程'] = tempSplit[1];
            tidyModelData['现病史']['机构'] = tempSplit[0];
            tidyModelData['主诉']['途径'] = tempSplit[0];
          }
        } else {
          tidyModelData['现病史']['外院'] = '否';
          tidyModelData['现病史']['机构'] = tidyModelData['主诉']['途径'];
        }
        // 主诉
        let dealwithZs = tidyModelData['主诉']['途径'];
        switch (dealwithZs) {
          case '学校体检':
            tidyModelData['主诉']['途径'] = '体检发现';
            break;
          case '本院检查':
          case '外院检查':
          case '眼镜店检查':
            tidyModelData['主诉']['途径'] = '检查发现';
            break;
          default:
            tidyModelData['主诉']['途径'] = '';
            break;
        }
        // 现病史
        let dealwithXbs = tidyModelData['现病史']['机构'];
        switch (dealwithXbs) {
          case '学校体检':
            tidyModelData['现病史']['机构'] = '学校';
            break;
          case '本院检查':
          case '外院检查':
            tidyModelData['现病史']['机构'] = '体检机构';
            break;
          case '眼镜店检查':
            tidyModelData['现病史']['机构'] = '眼镜店';
            break;
          default:
            tidyModelData['现病史']['机构'] = '';
            break;
        }
        let xbsFusion = tidyModelData['现病史']['描述'];
        let zsRequire = '';
        for (let i = xbsFusion.length - 1; i >= 0; i--) {
          if (['验光检查', '新配眼镜', '更换眼镜', '手术咨询'].includes(xbsFusion[i])) {
            zsRequire += (zsRequire.length ? `、${xbsFusion[i]}` : xbsFusion[i]);
            xbsFusion.splice(i, 1);
          }
        }
        if (zsRequire.length) {
          tidyModelData['主诉']['要求'] = zsRequire;
        }
        // tidyModelData['现病史']['描述'] = tidyModelData['现病史']['描述'].join(',');
        console.log('tidyModelData 首诊->>', qData, tidyModelData);
        generateMedicalHistory['主诉'] = this.firstVisitRule('主诉', tidyModelData);
        generateMedicalHistory['现病史'] = this.firstVisitRule('现病史', tidyModelData);
        generateMedicalHistory['既往史'] = this.firstVisitRule('既往史', tidyModelData);
        generateMedicalHistory['过敏史'] = this.firstVisitRule('过敏史', tidyModelData);
      } else {

        if (tidyModelData['现病史']['矫正视力']) {
          tidyModelData['现病史']['矫正视力'] = tidyModelData['现病史']['矫正视力'].includes('视力') ? tidyModelData['现病史']['矫正视力'] : `矫正视力${tidyModelData['现病史']['矫正视力']}`;
        }

        tidyModelData['现病史']['经历'] = `${tidyModelData['现病史']['经历']}${tidyModelData['现病史']['眼镜类型'] ? `，配戴${tidyModelData["现病史"]["眼镜类型"]}` : ''}${tidyModelData['现病史']['矫正视力'] ? `${tidyModelData["现病史"]["矫正视力"]}` : ''}${tidyModelData['现病史']['用阿托品的情况'] ? `，${tidyModelData["现病史"]["用阿托品的情况"]}` : ''}`;

        delete tidyModelData['现病史']['矫正视力'];
        delete tidyModelData['现病史']['眼镜类型'];
        delete tidyModelData['现病史']['用阿托品的情况'];
        delete tidyModelData["主诉"]["患者意图"];

        if (typeof tidyModelData['现病史']['其他不适'] === 'string') {
          tidyModelData['现病史']['其他不适'] = tidyModelData['现病史']['其他不适'].split(',');
        }
        // tidyModelData['现病史']['其他不适'] = tidyModelData['现病史']['其他不适'] ? tidyModelData['现病史']['其他不适'].split(',') : '';
        tidyModelData['主诉']['时间'] = this.getTimeCalcRes(visitLastTime);
        tidyModelData['现病史']['戴镜'] = tidyModelData['现病史']['戴镜'] === '是' ? '+' : '-';
        tidyModelData['现病史']['阿托品'] = tidyModelData['现病史']['阿托品'] === '是' ? '+' : '-';
        console.log('tidyModelData 复诊->>', qData, tidyModelData);

        // let tempModalTrainData = JSON.parse(JSON.stringify(tidyModelData));
        // tempModalTrainData['现病史']['经历'] = `${tempModalTrainData['现病史']['经历']}，${tempModalTrainData['现病史']['眼镜类型'] ? `配戴${tempModalTrainData['现病史']['眼镜类型']}，` : ''}${tempModalTrainData['现病史']['矫正视力'] ? `矫正视力${tempModalTrainData['现病史']["矫正视力"]}，` : ''}`;
        // delete tempModalTrainData['现病史']['眼镜类型'];
        // delete tempModalTrainData['现病史']['矫正视力'];
        // console.log(' tempModalTrainData->>', tempModalTrainData);

        generateMedicalHistory['主诉'] = this.replyVisitRule('主诉', tidyModelData);
        generateMedicalHistory['现病史'] = this.replyVisitRuleForXBS(tidyModelData);
        generateMedicalHistory['既往史'] = this.replyVisitRule('既往史', tidyModelData);
        generateMedicalHistory['过敏史'] = this.replyVisitRule('过敏史', tidyModelData);
      }
      return generateMedicalHistory;
    },
    // 保存并跳转新页面
    async handleToDetail() {
      const { code, qusetionResult, modelResult } = this.checkList(this.list);
      if (!code) {
        return;
      }
      let medicalRecord = this.getGenerateMedicalRecord(this.lastVisitDate, modelResult);
      // 保存问卷
      const result = await saveAnswer({
        modelDialogue: JSON.stringify(modelResult),
        modelResult: JSON.stringify(medicalRecord),
        answer: JSON.stringify({
          qusetionResult,
          templateData: this.list,
          modelDialogue: modelResult,
        }),
        templateId: this.templateId,
        visitNo: this.visitNo,
        answerId: this.id,
        patientId: this.patientId,
      });
      if (result.code == 200) {
        Toast.success("保存成功");
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.$router.push({ path: "/detail", query: { id: result.data.id } });
        }, 3000);
      } else {
        Toast.fail(result.msg);
      }
    },
    handleToHistory() {
      this.$router.push({ path: "/history", query: { patientId: this.peid } });
    },
    // 其它逻辑
    handleCheckbox(index, item) {
      const element = this.list[index];
      if (item.isOther) {
        element.isOther = !element.isOther;
        element.isOtherValue = "";
        this.setVancellBorder(index);
      }
    },
    setVancellBorder(index) {
      this.$nextTick(() => {
        const dom = document.getElementById("otherinput_" + index);
        if (dom) {
          const inputBox = dom.getElementsByClassName("van-cell");
          if (inputBox && inputBox.length > 0) {
            inputBox[0].style.border = "1px solid rgb(187, 187, 187)";
          }
        }
        // this.$refs.input[index].focus();
      });
    },
    handleRdiobox(index, item) {
      const element = this.list[index];
      if (item.isOther) {
        element.isOther = true;
        this.setVancellBorder(index);
      } else if (element.isOther) {
        element.isOther = false;
        element.isOtherValue = "";
      }
    },
    handleIsOtherHostial(index, item) {
      const element = this.list[index];
      if (item.label == "其它" && !element.isOther) {
        element.isOther = !element.isOther;
        element.isOtherHostial = false;
        element.isOtherValue = "";
        this.setVancellBorder(index);
      }
      if (item.label == "外院检查" && !element.isOtherHostial) {
        element.isOtherHostial = !element.isOtherHostial;
        element.isOther = false;
        element.isOtherValue = "";
        this.setVancellBorder(index);
      }
      if (item.label != "其它" && item.label != "外院检查") {
        element.isOtherHostial = false;
        element.isOther = false;
        element.isOtherValue = "";
      }
    },
    handleIsExpand(item) {
      // 如果当前选项的值与上一次选择的值相同，则跳过
      if (this.lastSelectedItem[item.id] === item.value) return;
      // 找到当前父级在 list 中的索引
      const index = this.list.findIndex((i) => i.id === item.id);
      // 获取当前父级的子集
      const childrenItem = item.children && item.children[item.value];
      // 移除之前的子集
      if (this.lastSelectedItem[item.id] !== undefined) {
        // 如果有上一次选择的子集，移除它们
        const lastChildren = item.children[this.lastSelectedItem[item.id]];
        const lastLength = Array.isArray(lastChildren) ? lastChildren.length : Object.prototype.toString.call(lastChildren) === '[object Object]' ? 1 : 0;
        if (lastLength) {
          this.list.splice(index + 1, lastLength);
        }
      }
      // 插入新的子集
      if (childrenItem) {
        if (Array.isArray(childrenItem)) {
          // 如果 childrenItem 是数组，平铺插入
          this.list.splice(index + 1, 0, ...childrenItem);
        } else {
          // 如果 childrenItem 是对象，直接插入
          this.list.splice(index + 1, 0, childrenItem);
        }
      }
      // 更新 lastSelectedItem
      this.lastSelectedItem[item.id] = item.value;
      return;
      const tenplateIndex = this.listData.findIndex((i) => i.id == item.id);
      const tempData = this.listData;
      for (let i = tenplateIndex; i < tempData.length; i++) {
        if (tempData[i].hasOwnProperty("isExpand") && length > 0) {
          tempData[i].isExpand = !tempData[i].isExpand;
          length = length - 1;
        }
      }
      const restData = tempData.filter((item, i) => {
        if (
          item.hasOwnProperty("isExpand") &&
          i > tenplateIndex &&
          count < temolatelwng
        ) {
          count++;
          return item.isExpand;
        }
      });
      let listData = [...this.list];
      if (restData && restData.length) {
        restData.forEach((item, i) => {
          listData.splice(index + 1 + i, 0, item);
        });
        this.list = listData;
      } else {
        this.list.splice(index + 1, temolatelwng);
      }
    },
    // 处理首诊摸版其它逻辑
    handleFirstCheckbox(index, item) {
      if (item && item.hasOwnProperty("isOther")) {
        item.isOther = !item.isOther;
        item.isOtherValue = "";
        this.setVancellBorder(index);
      } else {
        if (item.isSelect) {
          item.isSelect = "";
        } else {
          item.isSelect = "近视";
        }
      }
    },
    handleAddFirst(item, number) {
      item.number = parseInt(number) + 50;
    },
    handleDescFirst(item, number) {
      const num = parseInt(number);
      if (num - 50 <= 0) {
        return;
      }
      item.number = num - 50;
    },
    // type 类型 checkbox radio isOtherHostial新类型 mdw checkboxAndNumbe 新类型 isExpand

    checkList(list) {
      let code = true;
      let qusetionResult = [];
      let modelResult = [];
      function getResult(options, value) {
        let values = "";
        for (let i = 0; i < options.length; i++) {
          if (
            (Array.isArray(value) && value.indexOf(options[i].value) > -1 &&
            options[i].label != "其它") || (value.length === options[i].value.length && value.indexOf(options[i].value) > -1 &&
            options[i].label != "其它")
          ) {
            values += options[i].label + ",";
          }
        }
        if (values) {
          values = values.slice(0, -1);
          return {
            model: values,
          };
        } else {
          return {
            model: "",
          };
        }
      }
      if (Array.isArray(list)) {
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          // 多选框
          if (item.type === "checkbox") {
            if (item.required) {
              if (item.isOther && !item.isOtherValue) {
                code = false;
                Toast.fail("请填写必填项");
                break;
              } else if (item.value && !item.value.length) {
                code = false;
                Toast.fail("请填写必填项");
                break;
              } else {
                let { model } = getResult(item.options, item.value);
                let qusetionResultObj = {
                  题目key: "label",
                  题目名称: item.label,
                };
                if (item.isOther && item.isOtherValue) {
                  model = model + "," + item.isOtherValue;
                }
                qusetionResultObj = { ...qusetionResultObj, 答案: model };
                let modelResultObj = {
                  question: item.label,
                  answer: model,
                  key: item.key,
                };
                qusetionResult.push(qusetionResultObj);
                modelResult.push(modelResultObj);
              }
            } else {
              let modelResultObj = {
                question: item.label,
                key: item.key,
                answer: "",
              };
              if (item.isOther && !item.isOtherValue) {
                code = false;
              } else if (item.value && item.value.length) {
                code = true;
                let { model } = getResult(item.options, item.value);
                let qusetionResultObj = {
                  题目key: "label",
                  题目名称: item.label,
                };
                if (item.isOther && item.isOtherValue) {
                  model = model + "," + item.isOtherValue;
                }
                modelResultObj.answer = model;
                qusetionResultObj = { ...qusetionResultObj, 答案: model };
                qusetionResult.push(qusetionResultObj);
              }
              modelResult.push(modelResultObj);
            }
          }
          //  单选框
          if (item.type === "radio" || item.type === "isExpand") {
            if (item.required) {
              if (item.isOther && !item.isOtherValue) {
                code = false;
                Toast.fail("请填写必填项");
                break;
              }
              if (!item.value) {
                code = false;
                Toast.fail("请填写必填项");
                break;
              } else {
                let model = "";
                if (item.isOther && item.isOtherValue) {
                  model = item.isOtherValue;
                } else {
                  const { model: k } = getResult(item.options, item.value);
                  model = k;
                }
                let qusetionResultObj = {
                  题目key: "label",
                  题目名称: item.label,
                  答案: model,
                };
                let modelResultObj = {
                  question: item.label,
                  answer: model,
                  key: item.key,
                };
                qusetionResult.push(qusetionResultObj);
                modelResult.push(modelResultObj);
              }
            } else {
              let modelResultObj = {
                question: item.label,
                key: item.key,
                answer: "",
              };
              if (item.isOther && !item.isOtherValue) {
                code = false;
                break;
              }
              if (item.value) {
                code = true;
                let model = "";
                if (item.isOther && item.isOtherValue) {
                  model = item.isOtherValue;
                } else {
                  const { model: k } = getResult(item.options, item.value);
                  model = k;
                }
                modelResultObj.answer = model;
                let qusetionResultObj = {
                  题目key: "label",
                  题目名称: item.label,
                  答案: model,
                };
                qusetionResult.push(qusetionResultObj);
              }
              modelResult.push(modelResultObj);
            }
          }
          // 特殊情况
          if (item.type === "mdw") {
            if (!item.isOtherValue) {
              code = false;
              Toast.fail("请填写必填项");
              break;
            }
            const { model } = getResult(item.options, item.value);
            let modelResultObj = {
              question: item.label,
              answer: item.isOtherValue + model,
              key: item.key,
            };
            let qusetionResultObj = {
              题目key: "label",
              题目名称: item.label,
              答案: item.isOtherValue + model,
            };
            qusetionResult.push(qusetionResultObj);
            modelResult.push(modelResultObj);
          }
          // 输入框
          if (item.type === "textarea") {
            let modelResultObj = {
              question: item.label,
              key: item.key,
            };
            if (item.value) {
              modelResultObj.answer = item.value;
              let qusetionResultObj = {
                题目key: "label",
                题目名称: item.label,
                答案: item.value,
              };
              qusetionResult.push(qusetionResultObj);
            }
            modelResult.push(modelResultObj);
          }
          if (item.type == "checkboxAndNumbe") {
            const { code: c, value, label } = this.getcheckboxAndNumbe(item, i);
            let modelResultObj = {
              question: item.label,
              answer: value || "",
              key: item.key,
            };
            modelResult.push(modelResultObj);
            if (!c) {
              return { code: false };
            }
            let qusetionResultObj = {
              题目key: "label",
              题目名称: label,
              答案: value,
            };
            qusetionResult.push(qusetionResultObj);
          }
          if (item.type == "isOtherHostial") {
            // 包含外院检查
            const { code: c, value, label } = this.getIsOtherHostial(item, i);
            let modelResultObj = {
              question: item.label,
              answer: value || "",
              key: item.key,
            };
            modelResult.push(modelResultObj);
            if (!c) {
              return { code: false };
            }
            let qusetionResultObj = {
              题目key: "label",
              题目名称: label,
              答案: value,
            };
            qusetionResult.push(qusetionResultObj);
          }
        }
        return {
          code,
          qusetionResult,
          modelResult,
        };
      } else {
        Toast.fail("模板数据有问题");
        return {
          code: false,
          qusetionResult: [],
          modelResult: [],
        };
      }
    },
    // 验证包含外院检查 isOtherHostial
    getIsOtherHostial(item, i) {
      let code = true;
      let value = "";
      if (item.isOtherHostial) {
        if (!item.isOtherHostialValue) {
          Toast.fail("请填写必填项");
          return { code: false };
        }
        code = true;
        value += getValue(item.options) + ":" + item.isOtherHostialValue + ",";
        // console.log(value)
      }
      if (item.isOther) {
        if (!item.isOtherValue) {
          code = false;
          Toast.fail("请填写必填项");
          return {
            code,
          };
        }
        code = true;
        // value += "其它" + ":" + item.isOtherValue + ",";
        value += item.isOtherValue + ",";
      }

      let model = "";
      if (item.value && item.value.length) {
        code = true;
        model = this.getResult(item.options, item.value);
      }
      if (model) {
        value += model + ",";
      }
      function getValue(options) {
        let value = "";
        for (let i = 0; i < options.length; i++) {
          if (options[i].isOtherHostial && options[i].label != "其他") {
            value = options[i].label;
            break;
          }
        }
        return value;
      }
      if (value) {
        value = value.slice(0, -1);
      }
      return {
        code,
        value,
        label: item.label,
      };
    },
    getResult(options, value) {
      let values = "";
      for (let i = 0; i < options.length; i++) {
        if (
          value.indexOf(options[i].value) > -1 &&
          !options[i].isOther &&
          !options[i].isOtherHostial
        ) {
          values += options[i].label + ",";
        }
      }
      if (values) {
        values = values.slice(0, -1);
        return values;
      }
    },
    getcheckboxAndNumbe(item, i) {
      let label = item.label,
        value = "",
        valueOtherValue = "",
        code = true;
      const { options } = item;
      let count = 0;
      for (let j = 0; j < options.length; j++) {
        const elememt = options[j];
        console.log(' elememt->>', elememt);
        if (elememt.value && elememt.isOther) {
          if (!elememt.isOtherValue) {
            code = false;
            Toast.fail("请填写必填项");
            break;
          } else {
            code = true;
            value +=
              (value.length > 0 ? '，' : '') + (elememt.label == "其它" ? "" : elememt.label) +
              // ":" +
              elememt.isOtherValue 
              // + ",";
            valueOtherValue +=
              (valueOtherValue.length > 0 ? '，' : '') + (elememt.label == "其它" ? "" : elememt.label) +
              elememt.isOtherValue
          }
        } else if (elememt.value) {
          if (elememt.isSelect) {
            code = true;
            value +=
              (value.length > 0 ? '，' : '') + elememt.label +
              // ":" +
              this.getdICT(elememt.isSelect, elememt.number)
              // + ",";
            valueOtherValue += (valueOtherValue.length > 0 ? '，' : '') + elememt.label +
            // ":" +
            this.getLabel(elememt.isSelect, elememt.number);
          }
        } else {
          count += 1;
        }
      }
      // if (count == options.length) {
      //   code = false;
      //   Toast.fail("请选择第" + (i + 1) + "题的问题");
      // }
      // if (value) {
      //   value = value.slice(0, -1);
      // }
      if (valueOtherValue) {
        sessionStorage.setItem("valueOtherValue", valueOtherValue);
      }
      return {
        label,
        value,
        code,
      };
    },
    getdICT(type, number) {
      const n = (number / 100).toFixed(2);
      const list = {
        近视: `-${n}D`,
        远视: `+${n}D`,
        散光: `散光${n}D`,
        弱视: "弱视",
        斜视: "斜视",
        青光眼: "青光眼",
        先天性白内障: "先天性白内障",
      };
      return list[type];
    },
    getLabel(type, n) {
      const list = {
        近视: `近视${n}度`,
        远视: `远视${n}度`,
        散光: `散光${n}度`,
        弱视: "弱视",
        斜视: "斜视",
        青光眼: "青光眼",
        先天性白内障: "先天性白内障",
      };
      return list[type];
    },
    async getTenplatLiat(ids) {
      const visitNo = getValue("visitNo");
      const { patientId } = this;
      const result = await getTemplate(visitNo, patientId);
      if (result && result.code == 200) {
        try {
          if (
            result.data.id &&
            eval(result.data.templateContent) &&
            Array.isArray(eval(result.data.templateContent))
          ) {
            this.listData = eval(result.data.templateContent);
            if (this.listData && this.listData.length && ids.length) {
              for (let i = 0; i < this.listData.length; i++) {
                const index = ids.indexOf(this.listData[i].id);
                if (index > -1) {
                  this.listData[i].isExpand = true;
                }
                break;
              }
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    // 获取空摸版
    async getData() {
      const visitNo = getValue("visitNo");
      const { patientId } = this;
      const result = await getTemplate(visitNo, patientId);
      if (result && result.code == 200) {
        this.lastVisitDate = result.data.lastVisitDate;
        try {
          if (
            !result.data.id &&
            eval(result.data.answer) &&
            Array.isArray(eval(result.data.answer))
          ) {
            this.listData = eval(result.data.answer);
            this.list = this.listData.filter((item) => {
              if (item.hasOwnProperty("isExpand")) {
                return item.isExpand;
              } else {
                return true;
              }
            });
          } else {
            // 公共号再次跳转的复诊
            const { templateData } = JSON.parse(result.data.answer);
            this.listData = templateData;
            this.list = this.listData.filter((item) => {
              if (item.hasOwnProperty("isExpand")) {
                return item.isExpand;
              } else {
                return true;
              }
            });
          }
          this.visitNo = result.data.visitNo;
          this.templateId = result.data.templateId;
          // 再次修改数据
          this.id = result.data.id;
          this.modelStatus = result.data.modelStatus;
          this.peid = result.data.patientId;
        } catch (e) {
          console.log(e);
        }
      }
    },
    // 返回修改后的数据
    async geAawertData() {
      const { id } = this.$route.query;
      const result = await getAnswer(id);
      if (result.code == 200) {
        try {
          const { templateData } = JSON.parse(result.data.answer);
          this.lastVisitDate = result.data.lastVisitDate;
          this.list = templateData;
          this.list.forEach(item => {
            if (item.type === 'isExpand') {
              this.lastSelectedItem[item.id] = item.value;
            }
          });
          this.visitNo = result.data.visitNo;
          this.templateId = result.data.templateId;
          this.id = result.data.id;
          this.modelStatus = result.data.modelStatus;
          this.peid = result.data.patientId;
          const ids = [];
          if (templateData && templateData.length) {
            templateData.forEach((item) => {
              if (item.isExpand) {
                ids.push(item.id);
              }
            });
          }
          this.getTenplatLiat(ids);
        } catch (e) {
          console.log(e);
        }
      }
    },
    // 开始语音
    voiceStart(index) {
      this.indexActive = index;
      const item = this.list[index];
      if (item.type == "checkboxAndNumbe") {
        this.testVoice = true;
      }
      connectWebSocket(index);
    },
    // 聚焦

    handleFocus(index) {
      this.setVancellBorderFous(index);
    },
    setVancellBorderFous(index) {
      const dom = document.getElementById("item" + index);
      if (dom) {
        const inputBox = dom.getElementsByClassName("van-cell");
        if (inputBox && inputBox.length > 0) {
          inputBox[0].style.border = "1px solid #0f40f5";
        }
      }
    },
    handleBlur(index) {
      const dom = document.getElementById("item" + index);
      if (dom) {
        const inputBox = dom.getElementsByClassName("van-cell");
        if (inputBox && inputBox.length > 0) {
          inputBox[0].style.border = "1px solid rgb(187, 187, 187)";
        }
      }
    },
    handleSelectOptions(item){
      if(item.isSelect=="斜视"||item.isSelect=='弱视'||item.isSelect == '青光眼' || item.isSelect == '先天性白内障'){
        item.number ='0'
      }
    },
    // 语音结束
    voiceEnd() {
      this.indexActive = -1;
      recorder.stop();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-radio--horizontal,
/deep/.van-checkbox--horizontal {
  width: 33%;
  margin-right: 0;
  box-sizing: border-box;
}
// 200px
.index-container {
  .content {
    height: calc(100vh - 204px);
    overflow-y: auto;
    padding: 0 15px;
  }

  /deep/ .item {
    margin-top: 12px;
    .number_button {
      width: 36px;
    }
    .number {
      width: 64px;
      display: inline-block;
      text-align: center;
      border-radius: 2px;
    }
    .border-item {
      border: 1px solid rgb(187, 187, 187);
    }
    .item-option {
      padding: 6px;
      display: inline-block;
    }
    .item_buttom_center {
      .van-field__control {
        text-align: center;
      }
    }
  }

  .checkboxAndNumbe {
    font-size: 12px;
  }

  /* 扩散动画 */
  .circle {
    position: absolute;
    right: 0;
    top: 0;
    background: #2d57a0;
    animation-name: circleChange;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    border-radius: 50%;
  }

  @keyframes circleChange {
    0% {
      transform: scale(1);
      opacity: 0.95;
    }

    25% {
      transform: scale(1.2);
      opacity: 0.75;
    }

    50% {
      transform: scale(1.4);
      opacity: 0.5;
    }

    75% {
      transform: scale(1.6);
      opacity: 0.25;
    }

    100% {
      transform: scale(1.8);
      opacity: 0.05;
    }
  }

  .title {
    margin: 0;
    padding: 0;
    display: inline-block;
    margin-bottom: 12px;
    position: relative;
    font-size: 16px;
  }

  .title-before::before {
    content: "*";
    position: absolute;
    top: 4px;
    left: -6px;
    color: red;
  }

  .radio-font-size {
    font-size: 12px;
    margin-bottom: 8px;
  }

  .footer {
    height: 74px;
    display: flex;
    align-items: end;
    // margin-bottom: 6px;
  }
}
</style>
